export const appVersion = __APP_VERSION__
export const appCommit = __APP_COMMIT__
export const appBuildTime = __APP_BUILD_TIME__
export const repositoryUrl = __APP_REPOSITORY_URL__
export const paypalUrl = 'https://www.paypal.com/paypalme/florinbadita'
